import React, { useContext, useEffect, useState } from 'react'
import { func, array, object, bool } from 'prop-types'

import Row from '../Row'
import Stack from '@/component/Primitive/Stack'

import StandardRowLayout from './component/StandardRowLayout'
import FixedColumnRowLayout from './component/FixedColumnRowLayout'
import PaywallBarrier from '@/component/Primitive/PaywallBarrier'

import styles from './Layout.module.scss'
import { SignUpContext } from '@/component/Context/SignUpContext'

const Layout = ({
  layout,
  __url,
  article,
  instance,
  section,
  pageData,
  latestMagazineIssue,
  paywalled,
  eventUmbrella
}) => {
  const signupContext = useContext(SignUpContext)
  const userIsSubscribed =
    signupContext !== undefined && signupContext.userIsSubscribed
  const [restrict, setRestrict] = useState(userIsSubscribed)
  const [subscriber, setSubscriber] = useState(false)

  useEffect(() => {
    process.browser &&
      setSubscriber(window.localStorage.getItem('isNewsletterSubscriber'))
    if (subscriber) setRestrict(subscriber === 'false')
    else setRestrict(true)
    userIsSubscribed && setRestrict(false)
  }, [subscriber, userIsSubscribed])

  return (
    <div className={restrict && paywalled ? styles.clipped : null}>
      <Stack>
        {layout.map((row, rowIndex) => {
          const rowLayoutProps = {
            __url,
            article,
            section,
            instance,
            pageData,
            row,
            latestMagazineIssue,
            rowIndex,
            eventUmbrella
          }
          const rowHasAFixedColumn =
            row.attributes && row.attributes.includes('fixed-column')

          if (rowHasAFixedColumn) {
            return (
              <Row
                flex={rowHasAFixedColumn}
                key={rowIndex}
                row={row}
                isArticle={!!article}
              >
                <FixedColumnRowLayout
                  isArticle={!!article}
                  {...rowLayoutProps}
                />
              </Row>
            )
          }

          return (
            <Row key={rowIndex} row={row} isArticle={!!article}>
              <StandardRowLayout {...rowLayoutProps} />
            </Row>
          )
        })}
      </Stack>
      {restrict && paywalled && (
        <div className={styles.PaywallBarrierContainer}>
          <PaywallBarrier name={instance.name} />
        </div>
      )}
    </div>
  )
}

Layout.propTypes = {
  layout: array,
  __url: func.isRequired,
  article: object,
  section: object,
  instance: object,
  pageData: object,
  latestMagazineIssue: object,
  paywalled: bool,
  eventUmbrella: object
}

export default Layout
